module.exports = __webpack_public_path__ + "img/entering-the-country-with-a-dog-ua.3ea1e2ba.svg";